module.exports = __webpack_public_path__ + "img/map2_g.9f37bc68.svg";